import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { Modal, notification } from 'antd';

import Logout from '../../assets/icons/Logout';

import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import LiveClassCard from '../../components/LiveClass/LiveClassCard';
import Button from '../../components/Button/Button';
import { getPaidCourse } from '../../services/paymentService';
import * as profileServices from '../../services/profileService';
import CamOff from '../../assets/icons/CamOff';
import RightArrow from '../../assets/icons/RightArrow';
import Notif from '../../assets/icons/Notif';
import Spinner from '../../components/Spinner/Spinner';

const Profile = () => {
  let values = JSON.parse(localStorage.getItem('userData'));
  let query = new URLSearchParams(useLocation().search);
  let liveclass = query.get('classes');

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logoutVisible, setLogoutVisible] = useState(false);

  const [dropdowns, setDropdowns] = useState({
    bankName: false,
    accountType: false,
  });
  const [tab, setTab] = useState(
    liveclass === 'live' ? 'live-class' : 'profile'
  );
  const [paidCourses, setPaidCourses] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState({});
  const [accountType, setAccountType] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [accountName, setAccountName] = useState('');
  const [bankSearch, setBankSearch] = useState('');
  const [filteredBanks, setFilteredBanks] = useState('');
  const [percentage, setPercentage] = useState({
    school: '',
    teachers: '',
  });
  const [checkTerms, setCheckTerms] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [update, setUpdate] = useState(false);

  const resetDropdown = () => {
    setDropdowns({
      bankName: false,
      accountType: false,
    });
  };

  //cancel logout modal
  const handleCancel = () => {
    setLogoutVisible(false);
  };

  const initialValues = {
    email: '',
    password: '',
  };

  let { id } = JSON.parse(localStorage.getItem('userData'));
  let school = JSON.parse(localStorage.getItem('userData')).school;
  let token = localStorage.getItem('token');

  const getBankAccount = async () => {
    try {
      setLoading(true);
      let res = await profileServices.getBankDetails(school?.id, token);
      if (res.data.account_name) {
        setUpdate(true);
      }
      setAccountName(res.data.account_name);
      setAccountNumber(res.data.account_number);
      setAccountType(res.data.account_type);
      setSelectedBank({ name: res.data.bank_name });
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getSettlementRatio = async () => {
    try {
      setLoading(true);
      let res = await profileServices.getSettlementRatio(school?.id, token);
      setPercentage({
        ...percentage,
        school: res.data.school,
        teachers: res.data.teachers,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const resolve = async () => {
    setFetchLoading(true);
    let data = {
      accountNumber: accountNumber,
      bankCode: selectedBank?.code,
    };
    try {
      let res = await profileServices.resolveBankDetails(
        selectedBank?.id,
        token,
        data
      );
      setAccountName(res.data.account_name);
      setFetchLoading(false);
    } catch (error) {
      setFetchLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    const getPaidCourses = async () => {
      let course = await getPaidCourse(id, token);
      setPaidCourses(course.data.courses);
    };
    getPaidCourses();
    //getBankAccount();
    // getSettlementRatio();
  }, []);

  //filter bank
  useEffect(() => {
    let list = banks.filter((item) =>
      item.name.toLowerCase().includes(bankSearch.toLowerCase())
    );
    setFilteredBanks(list?.length > 0 ? list : banks);
  }, [bankSearch]);

  //get banks
  const getBanks = async () => {
    try {
      let res = await profileServices.getBanks();
      setBanks(res.data);
    } catch (error) {
      console.log(error);
      notification['error']({
        message: 'Unable to get banks',
      });
    }
  };

  //save bank details
  const save = async () => {
    let data = {
      accountNumber: accountNumber,
      accountName: accountName,
      accountType: accountType,
      bankId: selectedBank?.id,
      bankCode: selectedBank?.code,
      bankName: selectedBank?.name,
    };

    try {
      setLoading(true);
      update
        ? await profileServices.updateBankDetails(school?.id, token, data)
        : await profileServices.saveBankDetails(school?.id, token, data);
      setLoading(true);
      notification['success']({
        message: `Bank Account ${update ? 'Updated' : 'Saved'} Successfully`,
      });
      getBankAccount();
    } catch (error) {
      setLoading(false);
      console.log(error);
      notification['error']({
        message: error.response.data.message,
      });
    }
  };

  const setSettlement = async () => {
    try {
      setLoading(true);
      await profileServices.setSettlement(school?.id, token, percentage);
      setLoading(false);
      notification['success']({
        message: 'Settlement Ratio Saved Successfully',
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
      notification['error']({
        message: error.response.data.message,
      });
    }
  };

  //logic to share percentages
  const sharePercentage = (e) => {
    let fieldname = e.target.name;
    let value = e.target.value;

    if (value > 70) {
      return;
    }

    if (fieldname === 'school') {
      setPercentage({
        school: value,
        teachers: 70 - Number(value),
      });
    } else {
      setPercentage({
        school: 70 - Number(value),
        teachers: value,
      });
    }
  };

  //search for bank
  const handleBankSearch = (e) => {
    setBankSearch(e.target.value);
  };

  return (
    <div>
      <Helmet>
        <title>PL by Edves | Profile</title>
      </Helmet>
      <DashboardHeader />
      {loading ? (
        <Spinner />
      ) : (
        <div className='profile'>
          <div className='takecourse__breadcrumbs'>
            <span>
              <svg
                width='18'
                height='12'
                viewBox='0 0 18 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z'
                  fill='#161410'
                />
              </svg>
            </span>
            <p
              onClick={() =>
                navigate(values?.school ? '/tutor-dashboard' : '/dashboard')
              }
            >
              Home |
            </p>
            <span>
              <p style={{ color: '#161410' }}>Edit Profile</p>
            </span>
          </div>
          <div className='profile__content'>
            <div className='profile__content__left'>
              <div className='profile__content__left__user'>
                <div className='profile__content__left__user__image'>
                  <img src={values?.avatar || values.school?.logo} alt='' />
                </div>
                <h2>
                  {values?.first_name} {values?.last_name}
                </h2>
                <p>{values?.email}</p>
                {values?.school && (
                  <Button
                    text={'Copy School Unique Url'}
                    className='primary-btn'
                    onClick={() => {
                      navigator.clipboard.writeText(
                        values?.school?.link_id
                          ? `${window.location.hostname}/schools/${values?.school?.link_id}`
                          : `${window.location.hostname}/schools/${values?.school?.id}`
                      );
                      notification['success']({
                        message: 'Url copied!',
                      });
                    }}
                  />
                )}
              </div>

              <div className='profile__content__left__link-list'>
                <div
                  className={
                    tab === 'profile'
                      ? 'profile__content__left__link-list__single active-single'
                      : 'profile__content__left__link-list__single'
                  }
                  onClick={() => setTab('profile')}
                >
                  <svg
                    width='13'
                    height='12'
                    viewBox='0 0 13 12'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M0 9.5V12H2.5L9.87333 4.62667L7.37333 2.12667L0 9.5ZM1.94667 10.6667H1.33333V10.0533L7.37333 4.01333L7.98667 4.62667L1.94667 10.6667ZM11.8067 1.75333L10.2467 0.193333C10.1133 0.06 9.94667 0 9.77333 0C9.6 0 9.43333 0.0666666 9.30667 0.193333L8.08667 1.41333L10.5867 3.91333L11.8067 2.69333C12.0667 2.43333 12.0667 2.01333 11.8067 1.75333Z'
                      fill='#161410'
                    />
                  </svg>
                  <p>Edit Profile</p>
                </div>

                {!values?.school && (
                  <div
                    className={
                      tab === 'live-class'
                        ? 'profile__content__left__link-list__single active-single'
                        : 'profile__content__left__link-list__single'
                    }
                    onClick={() => setTab('live-class')}
                  >
                    <svg
                      width='12'
                      height='8'
                      viewBox='0 0 12 8'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M8 1.33333V6.66667H1.33333V1.33333H8ZM8.66667 0H0.666667C0.3 0 0 0.3 0 0.666667V7.33333C0 7.7 0.3 8 0.666667 8H8.66667C9.03333 8 9.33333 7.7 9.33333 7.33333V5L12 7.66667V0.333333L9.33333 3V0.666667C9.33333 0.3 9.03333 0 8.66667 0Z'
                        fill='#5A5955'
                      />
                    </svg>

                    <p>Live Class</p>
                  </div>
                )}

                {values?.school && (
                  <div
                    className={
                      tab === 'settings'
                        ? 'profile__content__left__link-list__single active-single'
                        : 'profile__content__left__link-list__single'
                    }
                    onClick={() => setTab('settings')}
                  >
                    <svg
                      width='12'
                      height='12'
                      viewBox='0 0 12 12'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M6 1.33333H10.6667V10.6667H6V12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.599999 11.4 0 10.6667 0H6V1.33333ZM6.44667 5.33333L4.72667 3.60667L5.66667 2.66667L9 6L5.66667 9.33333L4.72667 8.39333L6.44667 6.66667H0L0 5.33333H6.44667Z'
                        fill='#5A5955'
                      />
                    </svg>

                    <p>Profile settings</p>
                  </div>
                )}
                <div
                  className='profile__content__left__link-list__single '
                  onClick={() => setLogoutVisible(true)}
                >
                  <svg
                    width='12'
                    height='12'
                    viewBox='0 0 12 12'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M6 1.33333H10.6667V10.6667H6V12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.599999 11.4 0 10.6667 0H6V1.33333ZM6.44667 5.33333L4.72667 3.60667L5.66667 2.66667L9 6L5.66667 9.33333L4.72667 8.39333L6.44667 6.66667H0L0 5.33333H6.44667Z'
                      fill='#5A5955'
                    />
                  </svg>

                  <p>Log Out</p>
                </div>
              </div>
            </div>
            {tab === 'profile' && (
              <div className='profile__content__right'>
                <h2>Edit profile</h2>

                <div className='profile__content__right__avatar'>
                  <h4>Edit Avatar</h4>
                  <p>Change your profile avatar at anytime</p>
                  {/* <div className='profile__content__right__avatar__section'></div> */}
                </div>

                <div className='profile__content__right__avatar'>
                  <h4>Change Password</h4>
                  <p>
                    You can always change your password if you suspect any
                    illegal <br />
                    attempt into your profile
                  </p>

                  <div
                    className='auth-wrapper__right__form'
                    style={{
                      marginTop: '32px',
                      borderBottom: '1px solid #eeeeee',
                      paddingBottom: '40px',
                    }}
                  >
                    <Formik
                      initialValues={initialValues}
                      validationSchema={Yup.object({
                        password: Yup.string().required(
                          'Please Enter your password'
                        ),
                      })}
                      onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(false);

                        const data = { ...values };
                        console.log(data);
                      }}
                    >
                      {({ isValid, dirty, isSubmitting }) => (
                        <Form>
                          <div
                            className='auth-wrapper__right__form__inputwrapper eye-position'
                            style={{ marginBottom: '32px' }}
                          >
                            <label htmlFor='password'>Current Password</label>

                            <Field
                              type={showPassword ? 'text' : 'password'}
                              name='password'
                              id='password'
                              placeholder='Enter your current password'
                            />
                            <div
                              className='eye-icon'
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <AiOutlineEyeInvisible />
                              ) : (
                                <AiOutlineEye />
                              )}
                            </div>
                          </div>

                          <div
                            className='auth-wrapper__right__form__inputwrapper eye-position'
                            style={{ marginBottom: '32px' }}
                          >
                            <label htmlFor='password'>New Password</label>

                            <Field
                              type={showPassword ? 'text' : 'password'}
                              name='newPassword'
                              id='newPassword'
                              placeholder='Enter new password'
                            />
                            <div
                              className='eye-icon'
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <AiOutlineEyeInvisible />
                              ) : (
                                <AiOutlineEye />
                              )}
                            </div>
                          </div>

                          <div
                            className='auth-wrapper__right__form__inputwrapper eye-position'
                            style={{ marginBottom: '32px' }}
                          >
                            <label htmlFor='password'>Confirm Password</label>

                            <Field
                              type={showPassword ? 'text' : 'password'}
                              name='confirmPassword'
                              id='confirmPassword'
                              placeholder='Re- enter new password'
                            />
                            <div
                              className='eye-icon'
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <AiOutlineEyeInvisible />
                              ) : (
                                <AiOutlineEye />
                              )}
                            </div>
                          </div>

                          <Button
                            text={'Change Password'}
                            className='primary-btn'
                            disabled={
                              isSubmitting || !dirty || !isValid || loading
                            }
                            type='submit'
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>

                {!values?.school && (
                  <div
                    className='profile__content__right__avatar '
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <h4>Your analysis</h4>
                      <p>Download your pre- assessment analysis result</p>
                    </div>
                    <Button
                      text={'Download'}
                      className='primary-btn'
                      type='submit'
                    />
                  </div>
                )}
              </div>
            )}

            {tab === 'live-class' && (
              <>
                {!paidCourses ? (
                  <div className='live-class'>
                    <CamOff />
                    <h2>No upcoming live class</h2>
                    <p>
                      All your upcoming live classes will appear here. Start
                      learnng to <br /> book a one- on- one session with a
                      school/ tutor
                    </p>
                    <Button
                      text={'Start Learning'}
                      className='primary-btn'
                      onClick={() => {
                        navigate('/dashboard');
                      }}
                    />
                  </div>
                ) : paidCourses[0]?.live_classes.length === 0 ? (
                  <div className='live-class'>
                    <CamOff />
                    <h2>No upcoming live class for this course</h2>
                    <p>
                      All your upcoming live classes will appear here. Start
                      learnng to <br /> book a one- on- one session with a
                      school/ tutor
                    </p>
                    <Button
                      text={'Start Learning'}
                      className='primary-btn'
                      onClick={() => {
                        navigate('/dashboard');
                      }}
                    />
                  </div>
                ) : (
                  <div className='tutor-liveclasses__body__cards-wrapper__card'>
                    {paidCourses?.map((item) =>
                      item.live_classes.length > 0 ? (
                        item.live_classes?.map((el) => (
                          <div
                            key={el.id}
                            // onClick={() => {
                            //   setSelectedClass(
                            //     liveClasses.filter((item) => item.id === el.id)
                            //   );
                            //   setViewDetailsModal(true);
                            // }}
                          >
                            <LiveClassCard
                              person='student'
                              meetingUrl={el.meeting_url}
                              title={el.learning_focus}
                              subtitle={el.learning_focus}
                              when={el.schedules[0]?.day}
                              hostMeetingUrl={el.host_meeting_url}
                              time={`${new Date(
                                '1970-01-01T' +
                                  el.schedules[0]?.start_time +
                                  'Z'
                              ).toLocaleTimeString('en-US', {
                                timeZone: 'UTC',
                                hour12: true,
                                hour: 'numeric',
                                minute: 'numeric',
                              })} - ${new Date(
                                '1970-01-01T' + el.schedules[0]?.end_time + 'Z'
                              ).toLocaleTimeString('en-US', {
                                timeZone: 'UTC',
                                hour12: true,
                                hour: 'numeric',
                                minute: 'numeric',
                              })}  `}
                              startTime={el.schedules[0]?.start_time}
                              schedules={el.schedules}
                            />
                          </div>
                        ))
                      ) : (
                        <div className='live-class'></div>
                      )
                    )}
                  </div>
                )}
              </>
            )}

            {tab === 'settings' && (
              <div className='profile__content__right'>
                <h2>Account Settings</h2>
                <p className='profile__content__right__bold'>
                  Manage your account and set payment percentages for the <br />{' '}
                  teachers in your school
                </p>

                <div className='profile__content__right__settings'>
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%', marginBottom: '0px' }}
                    onClick={() => {
                      getBanks();
                      dropdowns.bankName
                        ? setDropdowns({ ...dropdowns, bankName: false })
                        : setDropdowns({ ...dropdowns, bankName: true });
                    }}
                  >
                    <label htmlFor='subject'>Select Bank Name</label>

                    <input
                      type='text'
                      name='bankName'
                      id='bankname'
                      placeholder={selectedBank.name}
                      disabled
                      value={selectedBank.name}
                    />
                    <div className='eye-icon'>
                      <RightArrow />
                    </div>
                  </div>
                  {dropdowns.bankName && (
                    <div
                      className='dropdown-wrapper__dropdown'
                      style={{ width: '50vw', paddingTop: '40px' }}
                    >
                      <input
                        type={'text'}
                        onChange={handleBankSearch}
                        className='dropdown-wrapper__dropdown__search'
                        placeholder='Search for bank'
                      />
                      {filteredBanks?.map((el) => (
                        <div
                          className='dropdown-wrapper__dropdown__item'
                          key={el.id}
                          onClick={() => {
                            setSelectedBank(el);
                            resetDropdown();
                          }}
                        >
                          <p>{el.name}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className='flex-to-column' style={{ margin: '32px 0' }}>
                    <div className='dropdown-wrapper w-50'>
                      <div
                        className='auth-wrapper__right__form__inputwrapper eye-position'
                        style={{ width: '100%', margin: '0' }}
                        onClick={() =>
                          dropdowns.accountType
                            ? setDropdowns({ ...dropdowns, accountType: false })
                            : setDropdowns({ ...dropdowns, accountType: true })
                        }
                      >
                        <label htmlFor='subject'>Bank account type</label>

                        <input
                          type='text'
                          name='className'
                          disabled
                          id='accountType'
                          value={accountType}
                          placeholder='Select your bank account type'
                        />
                        <div className='eye-icon'>
                          <RightArrow />
                        </div>
                      </div>
                      {dropdowns.accountType && (
                        <div className='dropdown-wrapper__dropdown'>
                          {[
                            { id: 1, name: 'Savings' },
                            { id: 2, name: 'Current' },
                          ].map((el) => (
                            <div
                              className='dropdown-wrapper__dropdown__item'
                              key={el.id}
                              onClick={() => {
                                setAccountType(el.name);
                                resetDropdown();
                              }}
                            >
                              <p>{el.name}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div
                      className='auth-wrapper__right__form__inputwrapper w-50 '
                      style={{ margin: '0' }}
                    >
                      <label htmlFor='subject'>Account number</label>

                      <input
                        type='text'
                        maxLength={10}
                        name='bankName'
                        id='bankname'
                        placeholder='Enter the bank account number'
                        value={accountNumber}
                        onBlur={() => {
                          resolve();
                        }}
                        onChange={(e) => setAccountNumber(e.target.value)}
                      />
                    </div>
                  </div>

                  <div
                    className='auth-wrapper__right__form__inputwrapper'
                    style={{ marginBottom: '32px' }}
                  >
                    <label htmlFor='subject'>Account name</label>
                    <div className='notif'>
                      <p>
                        Please make sure you input the exact name format on the
                        bank account
                      </p>
                    </div>

                    {fetchLoading ? (
                      <p>Please wait...</p>
                    ) : (
                      <input
                        type='text'
                        // disabled
                        name='accountName'
                        id='accountName'
                        placeholder='Enter account name'
                        value={accountName}
                        onChange={(e) => setAccountName(e.target.value)}
                        disabled={school?.country_id === 162}
                      />
                    )}
                  </div>
                  <div className='notif' style={{ marginBottom: '32px' }}>
                    <Notif />
                    <p>
                      Kindly enter your account details correctly, PL by Edves
                      will not <br /> be held responsible for payment deposited
                      into an incorrect account
                    </p>
                  </div>

                  {update ? (
                    <Button
                      text={
                        <p style={{ color: '#161410' }}>
                          {loading ? 'Updating...' : 'Update Account details'}
                        </p>
                      }
                      onClick={() => save()}
                      className='primary-btn'
                      disabled={
                        loading ||
                        accountName === '' ||
                        accountNumber === '' ||
                        accountType === '' ||
                        selectedBank?.name === ''
                      }
                    />
                  ) : (
                    <Button
                      text={
                        <p style={{ color: '#161410' }}>
                          {loading ? 'Saving...' : 'Save changes'}
                        </p>
                      }
                      onClick={() => save()}
                      className='primary-btn'
                      disabled={
                        loading ||
                        accountName === '' ||
                        accountNumber === '' ||
                        accountType === '' ||
                        selectedBank?.name === ''
                      }
                    />
                  )}
                </div>

                <div className='border-line' />

                <h2>Teacher payment management</h2>
                <p className='profile__content__right__bold'>
                  Set your school and teachers percentage share
                </p>

                <div className='profile__content__right__settings'>
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <label htmlFor='subject'>
                      What percentage share will your school earn?
                    </label>
                    <div className='select-input'>
                      <div className='dropdown-wrapper'>
                        <div className='percentage'>
                          <p>%</p>
                        </div>
                      </div>
                      <input
                        type={'number'}
                        max={70}
                        id='class'
                        placeholder='Enter number'
                        name='school'
                        value={percentage?.school}
                        onChange={sharePercentage}
                      />
                    </div>
                  </div>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <label htmlFor='subject'>
                      What percentage share will teachers earn?
                    </label>
                    <div className='select-input'>
                      <div className='dropdown-wrapper'>
                        <div className='percentage'>
                          <p>%</p>
                        </div>
                      </div>
                      <input
                        type={'number'}
                        max={70}
                        name='teachers'
                        id='class'
                        placeholder='Enter number'
                        value={percentage?.teachers}
                        onChange={sharePercentage}
                      />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        marginBottom: '32px',
                      }}
                    >
                      <Notif /> <p>Kindly note that platform cost is 30% </p>
                    </div>
                  </div>
                  <Button
                    text={
                      <p style={{ color: '#161410' }}>
                        {loading ? 'Saving...' : 'Save Changes'}
                      </p>
                    }
                    className='primary-btn'
                    onClick={() => setSettlement()}
                    disabled={
                      loading ||
                      !checkTerms ||
                      percentage?.school === '' ||
                      percentage?.teachers === ''
                    }
                  />
                </div>

                <div className='terms-flex'>
                  {/* <Checkbox /> */}
                  <input
                    type={'checkbox'}
                    value={checkTerms}
                    onChange={() => setCheckTerms(!checkTerms)}
                  />
                  <p>
                    By clicking save, you agree to the{' '}
                    <b>Terms and Conditions</b> of the platform
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <Modal
        width={606}
        visible={logoutVisible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Logout />
            </div>
            <h2>Log out</h2>
            <p>Are you sure you want to log out of your account?</p>
          </div>

          <Button
            text={'Yes'}
            className='primary-btn'
            width='100%'
            onClick={() => {
              setLogoutVisible(false);
              window.location.replace('/');
              localStorage.clear();
            }}
          />
          <div style={{ marginTop: '17px' }}>
            <Button
              text={'No'}
              className='cancel'
              width='100%'
              onClick={() => {
                setLogoutVisible(false);
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Profile;
